import React, { useEffect } from 'react';
import PoliticaPrivacidadeComponent from '~/components/PoliticaPrivacidade';

export default function PoliticaPrivacidade() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PoliticaPrivacidadeComponent
      nome="amz|mp"
      email="contato@amzmp.com.br"
      site="https://amzmp.com.br"
      cnpj="10.425.575/0001-00"
      endereco="Edifício Eagle Point Al. Araguaia, 1293 - Conj. 909 Alphaville, Barueri, São Paulo - 06455-000"
      razaoSocial="AMZ MARKETING PROMOCIONAL EIRELI ME"
      plataforma="Google"
      titleColor="#266971"
      contentTextColor="#266971"
      fontRootSize="50%"
    />
  );
}
